export default __webpack_public_path__ + "static/media/img_7289.16c3750c.jpeg";